import { useQuery } from '@apollo/react-hooks';
import { TimeZonesQuery } from './__generated__/TimeZonesQuery';
import { TIME_ZONES_QUERY } from './timeZones.query';

export const useTimeZones = () => {
  return useQuery<TimeZonesQuery>(TIME_ZONES_QUERY);
};
